import CountTable from './CountTable';

export default CountTable;
